function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.06,
  clipPath: "url(#visabackground0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.739 86.3931L88.0527 159.76H108.342L121.038 86.3931H100.739Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.0343 86.4759L51.1626 136.51L49.0439 128.955C45.1249 119.853 33.9992 106.78 20.9375 98.5409L39.108 159.725L60.5766 159.689L92.5289 86.4604L71.0343 86.4759Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.3446 91.7256C40.1653 87.2565 36.7472 85.9246 32.5046 85.7651H1.04803L0.787109 87.2257C25.2667 93.0782 41.4647 107.18 48.186 124.135L41.3446 91.7256Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.156 100.46C168.794 100.357 173.605 101.787 177.342 103.268L179.174 104.116L181.918 88.2148C177.9 86.7285 171.602 85.1343 163.743 85.1343C143.694 85.1343 129.562 95.0856 129.452 109.346C129.322 119.884 139.519 125.767 147.221 129.28C155.127 132.88 157.778 135.168 157.741 138.383C157.679 143.294 151.438 145.547 145.609 145.547C137.484 145.547 133.168 144.441 126.504 141.705L123.89 140.532L121.035 156.953C125.784 159.005 134.546 160.769 143.641 160.862C164.969 160.862 178.829 151.029 178.975 135.791C179.064 127.454 173.652 121.093 161.927 115.873C154.83 112.468 150.488 110.205 150.53 106.77C150.53 103.72 154.214 100.46 162.156 100.46Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.983 86.4756H218.307C213.438 86.4756 209.816 87.7819 207.677 92.5646L177.551 159.801H198.858C198.858 159.801 202.333 150.76 203.121 148.78C205.454 148.78 226.155 148.811 229.103 148.811C229.709 151.372 231.577 159.801 231.577 159.801H250.4L233.983 86.4756ZM208.96 133.764C210.63 129.552 217.044 113.259 217.044 113.259C216.934 113.46 218.698 109.016 219.747 106.255L221.114 112.58C221.114 112.58 225.002 130.097 225.816 133.764H208.96Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "visabackground0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 249.618,
  height: 246,
  fill: "white",
  transform: "translate(0.787109)"
})));

var SvgVisaBackground = function SvgVisaBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 246,
    viewBox: "0 0 251 246",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisaBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa-background.f42e7a1a.svg";
export { ForwardRef as ReactComponent };